<template>
  <div>
    <v-col class="pa-0">
      <span>Тип Анкеты*</span>
      <v-select
        outlined
        dense
        item-text="title"
        item-value="value"
        :disabled="disabled"
        :loading="loading"
        :value="detailsEntityType"
        :items="$options.detailsEntityTypes"
        :error-messages="detailsEntityTypesError"
        @change="$emit('change:details-entity-type', $event)"
      />
    </v-col>
    <v-col class="pa-0">
      <span>Анкета*</span>
      <v-autocomplete
        item-text="name"
        item-value="id"
        outlined
        dense
        hide-no-data
        clearable
        auto-select-first
        :hide-selected="false"
        :items="details"
        :loading="loading || isLoadingData"
        :disabled="disabled"
        :error-messages="detailsEntityIdError"
        :value="detailsEntityId"
        @change="$emit('change:details-entity-id', $event)"
      >
        <template v-slot:selection="data">
          <router-link :to="redirectToDetail(data.item.id)" v-bind="data.attrs">{{
              data.item.name
            }}</router-link>
        </template>
      </v-autocomplete>
    </v-col>
  </div>
</template>
<script>
import detailsEntityTypes from '@/configs/detailsEntityTypes'

import legalDetailQuery from '@/services/gql/types/LegalDetail/queries/legalDetail.graphql'
import personalDetailQuery from '@/services/gql/types/PersonalDetail/queries/personalDetail.graphql'
import legalDetails from '@/services/gql/types/LegalDetail/queries/legalDetails.graphql'
import personalDetails from '@/services/gql/types/PersonalDetail/queries/personalDetails.graphql'

export default {
  name: 'DetailComponent',
  detailsEntityTypes,
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    detailsEntityId: {
      type: Number,
      default: null
    },
    detailsEntityIdError: {
      type: Array,
      default: () => []
    },
    detailsEntityTypesError: {
      type: Array,
      default: () => []
    },
    detailsEntityType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      profileDetail: null,
      personalDetails: null,
      legalDetails: null,
      details: null
    }
  },
  computed: {
    getAccountId () {
      return this.profileDetail?.accountId || null
    },
    isLoadingData () {
      return this.$apollo?.queries?.profileDetail?.loading || this.$apollo?.queries?.personalDetails?.loading
    }
  },
  methods: {
    redirectToDetail (id) {
      if (this.detailsEntityType === 'PERSONAL') {
        return {
          name: 'page-personal-detail',
          params: { id }
        }
      } else if (this.detailsEntityType === 'LEGAL') {
        return {
          name: 'page-legal-detail',
          params: { id }
        }
      }
      return '#'
    }
  },
  apollo: {
    profileDetail: {
      fetchPolicy: 'network-only',
      query () {
        if (this.detailsEntityType === 'LEGAL') return legalDetailQuery
        else if (this.detailsEntityType === 'PERSONAL') {
          return personalDetailQuery
        }
      },
      skip () {
        return !this.detailsEntityId
      },
      variables () {
        return {
          where: {
            id: Number(this.detailsEntityId)
          }
        }
      },
      update (data) {
        if (this.detailsEntityType === 'LEGAL') return data.legalDetail
        if (this.detailsEntityType === 'PERSONAL') return data.personalDetail
      }
    },
    details: {
      fetchPolicy: 'network-only',
      query () {
        if (this.detailsEntityType === 'LEGAL') return legalDetails
        else if (this.detailsEntityType === 'PERSONAL') return personalDetails
      },
      skip () {
        return !this.getAccountId
      },
      variables () {
        return {
          where: {
            accountId: this.getAccountId
          }
        }
      },
      update (data) {
        if (this.detailsEntityType === 'LEGAL') return data.legalDetails.list
        if (this.detailsEntityType === 'PERSONAL') return data.personalDetails.list
      }
    }
  }
}

</script>
